import { render, staticRenderFns } from "./task_list.vue?vue&type=template&id=18d4d4f6&scoped=true&"
import script from "./task_list.vue?vue&type=script&lang=js&"
export * from "./task_list.vue?vue&type=script&lang=js&"
import style0 from "./task_list.vue?vue&type=style&index=0&id=18d4d4f6&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4d4f6",
  null
  
)

export default component.exports